(function() {
  let fetchController = null;

  function initDeliveryCard() {
    document.addEventListener('on:variant:change', function(evt) {
      const variant = evt.detail?.variant;
      const card = document.querySelector('.delivery-card');
      if (!card || !variant) return;

      if (!variant.available) {
        const unavailableTitle = card.dataset.unavailableTitle;
        const unavailableText = card.dataset.unavailableText;

        card.innerHTML = `
          <div class="delivery-card__label">${unavailableTitle}</div>
          <div class="delivery-card__dates">${unavailableText}</div>
        `;
      } else {
        const sectionId = card.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
        if (!sectionId) return;

        if (fetchController) fetchController.abort();
        fetchController = new AbortController();

        const url = `${window.location.pathname}?variant=${variant.id}&sections=${sectionId}`;
        fetch(url, { signal: fetchController.signal })
          .then(r => r.json())
          .then(data => {
            if (!data[sectionId]) return;
            const html = new DOMParser().parseFromString(data[sectionId], 'text/html');
            const newCard = html.querySelector('.delivery-card');
            if (newCard) card.replaceWith(newCard);
          })
          .catch(e => { if (e.name !== 'AbortError') console.error(e); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryCard);
  } else {
    initDeliveryCard();
  }
})();